import { FC } from 'react';
import { useSearchBar } from '@/hooks/useSearchBar';

export const SearchBar: FC = () => {
  const { handleSearchInputChange, handleSearchSubmit, searchQuery } = useSearchBar();

  return (
    <form onSubmit={handleSearchSubmit} className="flex-grow max-w-lg mx-4 mb-4 sm:mb-0">
      <input
        type="text"
        id="global-search"
        placeholder="Search prompts..."
        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-electric-blue"
        value={searchQuery}
        onChange={handleSearchInputChange}
        aria-label="Search prompts"
      />
    </form>
  );
};
